module.exports = {
    "im.messageList.productTitle": "產品信息",
    "im.messageList.orderNumber": "訂單號"
};